import {omit} from "@pg-mono/nodash";

import {hitGTMEcommercePurchase} from "../../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {IOfferDetailApplication} from "../../../../offer/types/IOfferDetailApplication";
import {ViewType} from "../../../../view_type/ViewType";
import {IApplicationData} from "../../../types/IApplicationData";
import {IApplicationReducerData} from "../../../types/IApplicationReducerData";
import {TinderMultiLeadProperty} from "../../../types/tinder_multi_lead/TinderMultiLeadProperty";

/** `item_source` required by analytics for every tinder multilead purchase. */
const TINDER_MULTI_LEAD_GTM_ITEM_SOURCE = "tinder_multilead";

export const hitTinderMultiLeadGtmPurchase = (params: {
    application: IApplicationData;
    offerDetail: IOfferDetailApplication;
    property: TinderMultiLeadProperty;
    viewType: ViewType | null;
}) => {
    const {application, offerDetail, property, viewType} = params;

    const data = {
        offer: {detail: offerDetail},
        vendor: {detail: property.offer.vendor},
        property: {detail: omit(property, ["offer"])}
    } as unknown as IApplicationReducerData;

    hitGTMEcommercePurchase(data, viewType, "standard", TINDER_MULTI_LEAD_GTM_ITEM_SOURCE, application);
};
import {omit} from "@pg-mono/nodash";

import {hitGTMEcommercePurchase} from "../../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {IOfferDetailApplication} from "../../../../offer/types/IOfferDetailApplication";
import {ViewType} from "../../../../view_type/ViewType";
import {IApplicationData} from "../../../types/IApplicationData";
import {IApplicationReducerData} from "../../../types/IApplicationReducerData";
import {TinderMultiLeadProperty} from "../../../types/tinder_multi_lead/TinderMultiLeadProperty";

/** `item_source` required by analytics for every tinder multilead purchase. */
const TINDER_MULTI_LEAD_GTM_ITEM_SOURCE = "tinder_multilead";

export const hitTinderMultiLeadGtmPurchase = (params: {
    application: IApplicationData;
    offerDetail: IOfferDetailApplication;
    property: TinderMultiLeadProperty;
    viewType: ViewType | null;
}) => {
    const {application, offerDetail, property, viewType} = params;

    const data = {
        offer: {detail: offerDetail},
        vendor: {detail: property.offer.vendor},
        property: {detail: omit(property, ["offer"])}
    } as unknown as IApplicationReducerData;

    hitGTMEcommercePurchase(data, viewType, "standard", TINDER_MULTI_LEAD_GTM_ITEM_SOURCE, application);
};
